import {Box, IconButton, Typography} from '@mui/material'
import {useIsRtl} from 'store/Store'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import {styled} from '@mui/system'

const SimplePagination = ({count, page, rowsPerPage = 10, onPageChange}) => {
    const isRtl = useIsRtl()

    const handleBackButtonClick = () => {
        onPageChange(page - 1)
    }

    const handleNextButtonClick = () => {
        onPageChange(page + 1)
    }

    const totalPages = Math.ceil(count / rowsPerPage)

    return (
        <PaginationContainer variant="outlined">
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page + 1 >= totalPages}
                aria-label="next page">
                {isRtl === 'rtl' ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <Typography>{`${page + 1}/${totalPages}`}</Typography>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page + 1 === 1}
                aria-label="previous page">
                {isRtl === 'rtl' ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
        </PaginationContainer>
    )
}

export default SimplePagination

const PaginationContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 'inherit';
    margin-top: 10px;
`
